import SMConst from 'lib/SMConst';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';

class SMOwnerHelper {
  static ownerEvaluationImage(evaluation){
    switch (evaluation) {
      case SMConst.OwnerEvaluation.Good:
        return SMRailsBridge.assetPath.evaluateGood;
        break;
      case SMConst.OwnerEvaluation.Average:
        return SMRailsBridge.assetPath.evaluateAverage;
        break;
      case SMConst.OwnerEvaluation.Bad:
        return SMRailsBridge.assetPath.evaluateBad;
        break;
      default:
        return SMRailsBridge.assetPath.evaluateUnevaluatable;
        break;
    }
  }
}
export default SMOwnerHelper;


// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMOwnerHelper.js